import { Box } from '@material-ui/core';
import React from 'react';
import ApplicationHeader from './ApplicationHeader';
import HeatMapLegend from './HeatMapLegend/HeatMapLegend';
import { CardStyleApplication, ApplicationTitle } from './ApplicationStyle';

const Application = ({
  heatMap,
  history,
  riskTableData,
  tableData,
  clickHandler,
  applicationLabel,
  setRowsPerPage,
  setPage,
  nextTableData,
  rowsPerPage,
  handleRequestSort,
  watch,
  setWatch,
  setRiskTablePage,
  setRiskTableRowsRowsPerPage,
  handleSetriskTableSortString,
  riskTableRowsPerPage,
  recomandationLoading,
  handlesetLoading,
  riskLoading,
  handleriskLoading,
  risknextTableData,
  order,
  orderBy,
  riskColumOrder,
  riskColumOderBy,
  handleTableRowClick,
  isTreemapApplication,
  pageType
}) => {
  return /*#__PURE__*/React.createElement(CardStyleApplication, null, /*#__PURE__*/React.createElement(ApplicationTitle, null, applicationLabel), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "16px"
  }, /*#__PURE__*/React.createElement(HeatMapLegend, {
    color: "#FFB41E",
    title: "Very High"
  }), /*#__PURE__*/React.createElement(HeatMapLegend, {
    color: "#4A66F1",
    title: "High"
  }), /*#__PURE__*/React.createElement(HeatMapLegend, {
    color: "#571EB3",
    title: "Medium"
  }), /*#__PURE__*/React.createElement(HeatMapLegend, {
    color: "#0E804B",
    title: "Low"
  })), /*#__PURE__*/React.createElement(ApplicationHeader, {
    heatMap: heatMap,
    clickHandler: clickHandler,
    history: history,
    riskTableData: riskTableData,
    tableData: tableData,
    setRowsPerPage: setRowsPerPage,
    setPage: setPage,
    nextTableData: nextTableData,
    rowsPerPage: rowsPerPage,
    handleRequestSort: handleRequestSort,
    watch: watch,
    setWatch: setWatch,
    setRiskTablePage: setRiskTablePage,
    setRiskTableRowsRowsPerPage: setRiskTableRowsRowsPerPage,
    handleSetriskTableSortString: handleSetriskTableSortString,
    riskTableRowsPerPage: riskTableRowsPerPage,
    recomandationLoading: recomandationLoading,
    handlesetLoading: handlesetLoading,
    riskLoading: riskLoading,
    handleriskLoading: handleriskLoading,
    risknextTableData: risknextTableData,
    order: order,
    orderBy: orderBy,
    riskColumOrder: riskColumOrder,
    riskColumOderBy: riskColumOderBy,
    handleTableRowClick: handleTableRowClick,
    isTreemapApplication: isTreemapApplication,
    pageType: pageType
  }));
};

export default Application;